import React, { PureComponent } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import styles from "./ParameterSettings.local.scss";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import _ from "i18n";
import moment from "moment";
import { onSuccess, onError } from "Utils";
import { setEffectiveBenchmark, initParameterSettings } from "Actions";
import {
  fetchParameterSettings,
  saveParameterSettings,
  fetchCollaboratorSettingSuggestions
} from "Thunks";
import SynchronizationParameters from "./SynchronizationParameters";
import AuthorizationsParamaters from "./AuthorizationsParamaters";
import PriceList from "./PriceList";

const currentYear = moment().year();
const years = Array.from({ length: 5 }, (_, i) => currentYear - 3 + i);

class ParameterSettingsPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      year: moment().year(),
      disabledSave: true
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { year } = this.state;
    dispatch(fetchParameterSettings(year));
    dispatch(fetchCollaboratorSettingSuggestions());
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  renderYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;
    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
        style={{
          background: this.state.disabledYearDiv ? "#f1f2f4" : "#6d7f92",
          color: this.state.disabledYearDiv ? "#8d8d8d" : "#ffffff"
        }}
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={"icon icon-arrow-down"}
                  style={{
                    color: this.state.disabledYearDiv ? "#8d8d8d" : "#ffffff"
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(initParameterSettings());
    dispatch(fetchParameterSettings(year));
  };

  handleChangeEffectiveBenchmark = event => {
    const { dispatch } = this.props;
    dispatch(setEffectiveBenchmark(event.target.value));
    this.handleDisabledSave(false);
  };

  handleDisabledSave = value => {
    this.setState({
      disabledSave: value
    });
  };

  saveParameterSettings = () => {
    const { dispatch } = this.props;
    const { year } = this.state;
    dispatch(saveParameterSettings(year)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("parametersUpdated")
        });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
    this.handleDisabledSave(true);
  };

  render() {
    const { fetched, fetching, data, user } = this.props;

    return (
      <div className={classnames(styles.settings_parameters, "page-content")}>
        <SettingPageHeader
          title={_("parameterSettings")}
          onBack={() => this.handleRedirectBack()}
        />

        <div className={styles.parameters_block}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("parameterSettings")}</h2>
            <h3 className={styles.subtitle}>
              {user &&
              (user.type === "ADMIN" || user.type === "ADMIN_SUPERVISOR")
                ? _("parameterSettingsParameterBenchmark")
                : _("parameterBenchmark")}
            </h3>
          </div>
          <div className={styles.tabs_block}>
            {this.renderYearSelect()}
            <button
              type="button"
              className={classnames(styles.save_button)}
              disabled={this.state.disabledSave}
              onClick={this.saveParameterSettings}
            >
              <img
                src={"/img/icons/tail-spin.svg"}
                alt={""}
                className={this.props.saving ? styles.loading : ""}
              />
              {_("save")}
            </button>
          </div>
          {fetching && (
            <div className={styles.ripple_loading_adapted}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          )}
          {fetched &&
            !fetching && (
              <div className={classnames("row", styles.block)}>
                {user &&
                (user.type === "ADMIN" || user.type === "ADMIN_SUPERVISOR") ? (
                  <div className={classnames("columns medium-6 small-6")}>
                    <SynchronizationParameters
                      data={data}
                      handleDisabledSave={this.handleDisabledSave}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className={classnames("columns medium-6 small-6")}>
                  <div className={styles.tab_synchronization}>
                    <div className={styles.header}>
                      <span>{_("parameterOrganization")}</span>
                    </div>
                    <div className={styles.benchmark_parameter}>
                      <span>{_("annualBenchmark")}</span>
                      <input
                        type={"number"}
                        placeholder={_("enterAnnualBenchmark")}
                        value={data.benchmarkValue ? data.benchmarkValue : ""}
                        onChange={e => this.handleChangeEffectiveBenchmark(e)}
                        required={true}
                      />
                    </div>
                    <div className={styles.message_info}>
                      <span>*** {_("messageInfoBenchmark")}</span>
                    </div>
                  </div>
                </div>

                <div className={classnames("columns medium-6 small-6")}>
                  <AuthorizationsParamaters
                    data={data}
                    handleDisabledSave={this.handleDisabledSave}
                  />
                </div>

                <div className={classnames("columns medium-6 small-6")}>
                  <PriceList
                    data={data}
                    handleDisabledSave={this.handleDisabledSave}
                    settingSuggestions={this.props.settingSuggestions}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.parameterSettings.fetching,
  fetched: state.parameterSettings.fetched,
  saving: state.parameterSettings.saving,
  user: state.auth.user,
  data: state.parameterSettings.data,
  saved: state.parameterSettings.saved,
  organization: state.timeSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  settingSuggestions: state.collaborator.settingSuggestions
});

export default connect(mapStateToProps)(ParameterSettingsPage);



// WEBPACK FOOTER //
// ./src/components/ParameterSettings/ParameterSettingsPage.js